/**
 * Provisioning Wizard Store (MPRN-6)
 *
 * Tracks the merchant the creation wizard is actively polling, so the global
 * `useMerchantReadySync` realtime toast can SKIP a merchant the wizard is already
 * confirming inline (avoids a redundant toast over the wizard's success screen on
 * the direct-registration path A). For paths B/C the wizard isn't open, so the
 * realtime toast is the channel that reaches the owner.
 */
import { create } from 'zustand';

interface ProvisioningWizardState {
  /** The merchant_guid the open wizard is polling, or null when no wizard is active. */
  activeMerchantGuid: string | null;
  setActiveMerchant: (merchantGuid: string | null) => void;
}

export const useProvisioningWizardStore = create<ProvisioningWizardState>((set) => ({
  activeMerchantGuid: null,
  setActiveMerchant: (merchantGuid) => set({ activeMerchantGuid: merchantGuid }),
}));
